<template>
  <md-menu
    md-size="medium"
    class="tab-dropdown"
    :class="{ 'selected': selected }"
    md-align-trigger
    @md-opened="onMenuOpened"
  >
    <md-button class="tab-button" md-menu-trigger>
      {{ label }}
      <md-icon>arrow_drop_down</md-icon>
    </md-button>

    <md-menu-content>
      <md-menu-item
        v-for="item in items"
        :key="item.key"
        class="dropdown-menu-item"
        @click="onItemClick(item)"
      >
        {{ item.label }}
      </md-menu-item>
    </md-menu-content>
  </md-menu>
</template>

<script>
export default {
  name: 'tab-dropdown',
  props: {
    label: {
      type: String,
      default: 'Name goes here'
    },
    items: {
      type: Array,
      default: () => []
    },
    selected: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    onMenuOpened() {
      this.$emit('selectMenu');
    },
    onItemClick(item) {
      this.$emit('selectItem', item.key);
    }
  }
}
</script>

<style scoped>
.tab-dropdown.selected {
  border-bottom: 2px solid #84B2FF;
}
.tab-button {
  font-size: 16px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  padding: 4px 6px;
}
.dropdown-menu-item {
  cursor: pointer;
}
.dropdown-menu-item:hover {
  background-color: #e1e1e1;
}
</style>